<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Rental management system by Nouveta LTD" name="description" />
      <meta content="Kelvin Njuguna" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <link href="assets/libs/select2/css/select2.min.css" rel="stylesheet" type="text/css" />

      <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/spectrum-colorpicker2/spectrum.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/bootstrap-timepicker/css/bootstrap-timepicker.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/bootstrap-touchspin/jquery.bootstrap-touchspin.min.css" rel="stylesheet" type="text/css" />
      <link rel="stylesheet" href="assets/libs/%40chenfengyuan/datepicker/datepicker.min.css">



      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Bootstrap select styling -->
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body  data-sidebar="dark">

    <NavigationBar/>

    <!-- Search for bill -->
    <div class="modal fade " id="searchBillModal" data-backdrop="static" data-keyboard="false" tabindex="-1 " role="dialog " aria-labelledby="staticBackdropLabel " aria-hidden="true ">
      <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content ">
          <div class="modal-header border-bottom-0 ">
            <button type="button " class="btn-close d-none" data-dismiss="modal"  aria-label="Close "></button>
          </div>
          <div class="modal-body ">
            <div class="text-center mb-4 ">
              <div class="avatar-md mx-auto mb-4 ">
                <div class="avatar-title bg-light rounded-circle text-success h1 ">
                  <i class="bx bx-receipt "></i>
                </div>
              </div>

              <div class="row justify-content-center ">
                <div class="col-xl-10 ">
                  <h4 class="text-primary ">Enter Bill Number To continue

                  </h4>
                  <p class="text-muted font-size-14 mb-4 ">
                    Enter bill No to continue.
                  </p>

                  <form>
                    <div class="row ">
                      <div class="col-12 ">
                        <div class="mb-3 ">
                          <label for="digit1-input" class="visually-hidden ">Bill No.</label>
                          <input  v-model="billNo" type="text" class="form-control form-control-lg text-center two-step " placeholder="Search for Bill">
                        </div>
                      </div>
                    </div>
                    <button data-dismiss="modal" @click="getBill()" type="button" class="btn btn-success btn-block w-100 ">
                      <i class="bx bx-search-alt-2 font-size-16 align-middle me-2 "></i>
                      Search
                    </button>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search for bill -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Recruitment Rejections</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Employee</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- stats cards -->
          <div class="row">
            <!-- Total Pending Approvals -->
            <div class="col-lg-4 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pending Approvals</p>
                      <h5 class="mb-0">0</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clock-outline"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Approved Recruits -->
            <div class="col-lg-4 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Approved Recruits</p>
                      <h5 class="mb-0">0</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="mdi mdi-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Rejected Applications -->
            <div class="col-lg-4 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Rejected Applications</p>
                      <h5 class="mb-0">0</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="mdi mdi-close-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- end of stats -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3 pe-3">
                        <div>
                          <div class="float-end d-flex ">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Department</label>
                              <select class="form-select " style="width: 200px;">
                                <option selected="selected" value="">All Departments</option>
                                <option value="65">Finance &amp; Economic Planning</option>
                                <option value="67">Governance, Administration, Communication &amp; Devolution</option>
                                <option value="73">Education, Human Capital Development &amp; Vocational Training</option>
                                <option value="62">Blue Economy, Fisheries, Mining &amp; Digital Economy</option>
                                <option value="66">Roads, Public Works, Transport &amp; Infrastructure</option>
                                <option value="61">Youth, Sports, Talent Development, Gender Inclusivity, Cultural Heritage &amp; Social Services</option>
                                <option value="63">Water, Irrigation, Sanitation, Environment, Energy, Forestry &amp; Climate Change</option>
                                <option value="68">Public Health &amp; Medical Services</option>
                                <option value="64">Lands, Physical Planning, Housing &amp; Urban Development</option>
                                <option value="69">Trade, Industry, Tourism, Co-Operative Development and Marketing</option>
                                <option value="70">Agriculture and Livestock Production</option>
                                <option value="72">Office of the County Secretary and Head of Public Service</option>
                              </select>
                            </div>

                            <div class="input-group fw-semibold text-uppercase">
                              <label class="input-group-text text-uppercase">FROM:</label>
                              <input class="form-control form-control-sm" type="date" value="2019-08-19" id="example-date-input">
                            </div>

                            <div class="input-group fw-semibold text-uppercase">
                              <label class="input-group-text text-uppercase">TO:</label>
                              <input class="form-control form-control-sm" type="date" value="2019-08-19" id="example-date-input">
                            </div>
                          </div>
                        </div>
                      </div>
                      <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download  font-size-16"></i> <span class="pl-1 d-md-inline">Download Report</span>
                      </button>

                    </div>


                  </div>
                  <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                    <button type="button" data-bs-toggle="modal" data-bs-target=".download-modal" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-printer label-icon"></i> Print Selected Invoices</button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive ">

                    <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">App No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">ID No.</th>
                        <th scope="col">Contract Type</th>
                        <th scope="col">Proposed Salary</th>
                        <th scope="col">Department</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Date Added</th>
                        <th scope="col">Submitted By</th>
                        <th scope="col" class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in employeeData" :key="index">
                        <th>{{ item.id }}</th>
                        <td><a  @click="gotTo(item.id,'employee-approvals-new-verification')" href="javascript: void(0);">{{ item.firstName }} {{ item.lastName }}</a></td>
                        <td>{{ item.nationalId }}</td>
                        <td>{{ item.contractType }}</td>
                        <td>KES {{ item.salary }}</td>
                        <td>{{ item.department }}</td>
                        <td>{{ item.designation }}</td>
                        <td>{{ item.dateCreated }}</td>
                        <td>{{ item.createdBy }}</td>
                        <td class="text-right">
                          <a @click="gotTo(item.id,'employee-approvals-new-verification')" href="javascript: void(0);" class="btn btn-sm btn-success mx-2">Verify & Approve</a>
                          <a href="javascript: void(0);" class="d-none btn btn-sm btn-primary mx-2">Edit</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>


                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- receipting modal -->
      <div class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Food Handler Certificate Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Patient Details</strong><br>
                    Mrs Jane Doe<br>
                    <a href="mailto:email@mail.com">email@mail.com</a>, <a href="tel:+254704549859">0704 549 859</a><br>

                    <br>
                    Valid From 1 Mar 2022, 10:20 AM
                    <br>
                    <span class="pr-2">Valid Till 2 Mar 2023, 10:20 AM </span>
                    <span class="badge rounded-pill bg-success text-uppercase me-3">Active</span>

                  </address>
                </div>

                <div class="col-6 text-right">
                  <address>
                    <strong class="text-capitalize">Location Details</strong><br>
                    Street/Road: Mombasa Road<br>
                    Plot No.: 122202/1250<br>
                    Building: The Tower. Floor: 12. Door/Stall No.: 123<br/>
                    Subcounty: CBD. Ward: Mututu


                  </address>
                </div>

                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme  navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">12 Sep 2023 10:09 AM</div>
                            <h5 class="mb-4">Application</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize">Self Service Portal</p>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">13 Sep 2023 10:09 AM</div>
                            <h5 class="mb-4">Lab Test</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3 text-capitalize">
                            <p class="text-muted">Dr Mary Jane at Taifa Clinic</p>
                            <a href="PrintDocs/health-result-slip-master/health-result-slip-master/slip33.html" target="_blank" type="button" class="btn btn-link waves-effect"><i class="mdi mdi-eye-outline"></i> View Result Slip</a>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">14 Sep 2023 12:57 PM</div>
                            <h5 class="mb-4">Approved</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted">Mary Max</p>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">15 Sep 2023 12:54 PM</div>
                            <h5 class="mb-4">Certification</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted">Certifcate Issued By Kiprop Tanui</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-sm-6 text-sm-end d-none">
                  <address class="mt-2 mt-sm-0">
                    <strong>Payment Method</strong><br>
                    <span class="fw-medium">MPESA</span><br>
                    Phone No. 0704 549 859<br> <br>
                    On 1 Mar 2022, 10:20 AM
                  </address>
                </div>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">ND12368</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">
                    <thead class="bg-light">
                    <tr>
                      <th>More Details</th>
                      <th class="text-end"></th>

                    </tr>
                    </thead>

                    <tbody>
                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Serial Number</p>
                      </td>
                      <td class="">12WER345</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Owner(s)</p>
                      </td>
                      <td class="">John Doe Kamau, James Kuria Kimotho</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Profession/Occupation</p>

                      </td>
                      <td class="">Food Processing</td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Application Date</p>

                      </td>
                      <td class="">5 Jan 2022 10:09 AM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Date Approved</p>

                      </td>
                      <td class="">11 Jan 2022 09:54 AM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Days To Expiry</p>

                      </td>
                      <td class="">134 Days</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Amount Paid</p>

                      </td>
                      <td class="text-uppercase">KES 1,000</td>

                    </tr>




                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of receipting modal -->

      <!-- invoice details -->
      <div class="modal fade invoice-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Invoice Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <address>
                  <strong>Billed To:</strong><br>
                  Kelvin Njuguna<br>
                  email@mail.com, 0704 549 859<br>
                  Hse No. 410, 90 Degrees By Tsavo
                  <br><br>
                  1 Mar 2022, 10:20 AM
                </address>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">Invoice Details ( <span class="text-primary fw-medium">No. 1237</span> )</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap">
                    <thead>
                    <tr>
                      <th style="width: 70px;">No.</th>
                      <th>Item</th>
                      <th class="text-end">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>01</td>
                      <td>Rent Deposit</td>
                      <td class="text-end">KES 24,500</td>
                    </tr>

                    <tr>
                      <td>02</td>
                      <td>Monthly Rent</td>
                      <td class="text-end">KES 12,000</td>
                    </tr>

                    <tr>
                      <td>03</td>
                      <td>TAX (18%)</td>
                      <td class="text-end">KES 250</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end">Total</td>
                      <td class="text-end fw-bold">KES 36,750</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end">Paid</td>
                      <td class="text-end  fw-bold">KES 0.00</td>
                    </tr>

                    <tr>
                      <td colspan="2" class="border-0 text-end">
                        <strong>Balance</strong></td>
                      <td class="border-0 text-end">
                        <h5 class="m-0 text-uppercase fw-bold">KES 36,750</h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="col-12 d-none">
                <div class="table-resposive p-4 px-2 pt-2 overflow-visible">
                  <table class="w-100">
                    <tbody>
                    <tr data-id="1">
                      <td>
                        <label for="" class="">Payment Method</label>
                        <select class="form-control selectpicker w-100 payment-method" data-style="btn-secondary w-100" data-live-search="true" title="Select payment Method">
                          <option value="Mpesa">MPESA</option>
                          <option value="Cash">CASH</option>
                        </select>
                      </td>
                      <td class="px-3 ">
                        <div class="phone-num d-none">
                          <label for="">Phone No.</label>
                          <input type="text " class="form-control w-100 d-flex " placeholder="Phone No." spellcheck="false" data-ms-editor="true">
                        </div>

                      </td>
                      <td class="px-3">
                        <label for="">Amount To Be Paid</label>
                        <input type="text " class="form-control w-100 d-flex" placeholder="KES" spellcheck="false" data-ms-editor="true">

                      </td>
                      <td class="text-right float-right">
                        <div class="d-flex flex-column">
                          <label class="opacity-0">Something</label>
                          <a href="#" class="btn btn-primary w-md waves-effect waves-light">Submit</a>
                        </div>
                      </td>


                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <div class="float-end">
                <a href="javascript:window.print()" class="btn btn-success waves-effect waves-light me-1"><i class="mdi mdi-printer font-16px"></i></a>
                <a href="javascript: void(0);" class="btn btn-primary w-md waves-effect waves-light">Receive Payment</a>
              </div>
            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- invoice details -->

      <!-- patients details modal -->
      <div class="modal fade patient-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">More Details On Jane</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Patient Details</strong><br>
                    Mrs Jane Doe<br>
                    <a href="mailto:email@mail.com">email@mail.com</a>, <a href="tel:+254704549859">0704 549 859</a><br>

                    <br>
                    Registered on 1 Mar 2022, 10:20 AM <br>At Sipital Kuu Medical Center
                    <br>
                    <br>
                    <span class="pr-2">Last Seen: 10    Mar 20233. 03:46 PM</span>
                    <span class="badge rounded-pill bg-success text-uppercase me-3 d-none">Active</span>

                  </address>
                </div>

                <div class="col-6 text-right">
                  <address>
                    <strong class="text-capitalize">Location Details</strong><br>
                    County: Busia, Sub County: Funyula, Ward: Marachi West,
                    <br>
                    Physical Address: Near Karachi West Primary School


                  </address>
                </div>

                <div class="col-sm-6 text-sm-end d-none">
                  <address class="mt-2 mt-sm-0">
                    <strong>Payment Method</strong><br>
                    <span class="fw-medium">MPESA</span><br>
                    Phone No. 0704 549 859<br> <br>
                    On 1 Mar 2022, 10:20 AM
                  </address>
                </div>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">ND12368</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">
                    <thead class="bg-light">
                    <tr>
                      <th>More Details</th>
                      <th class="text-end"></th>

                    </tr>
                    </thead>

                    <tbody>
                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Patient ID</p>
                      </td>
                      <td class="">MPI/1234</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Blood Group</p>
                      </td>
                      <td class="">A+</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Age</p>

                      </td>
                      <td class="">22 Years</td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Marital Status</p>

                      </td>
                      <td class="">Single</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Occupation</p>

                      </td>
                      <td class="">Software Developer</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Gender</p>

                      </td>
                      <td class="">Male</td>

                    </tr>

                    <tr>
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Height</p>

                      </td>
                      <td class="">156 CM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Weight</p>

                      </td>
                      <td class="">78 KGs</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Unpaid Bills Amount</p>

                      </td>
                      <td class="">KES 400</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Last Updated</p>

                      </td>
                      <td class="">12 Jul 2023, 11:45 AM By Kennedy Livondo at Costa Rick Hospital</td>

                    </tr>




                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of patieonts details modal -->

      <!-- kin details modal -->
      <div class="modal fade kin-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Jane's Kin Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">


                    <tbody>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Relationship with patient</p>
                      </td>
                      <td class="">Brother</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Full Names</p>
                      </td>
                      <td class="">Alex Kinoti Livondo</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Phone Number</p>
                      </td>
                      <td class="">
                        <a href="tel:+254712345678">0712 345 678</a>
                      </td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Email Address</p>

                      </td>
                      <td class=""><a href="mailto:Alex@kinoti.com">Alex@kinoti.com</a></td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical Address</p>

                      </td>
                      <td class="">Near Mount Kilimanjaro Joint</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer d-none">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of kin details modal -->

      <!-- Patient registration -->
      <div class="modal fade " id="registerCustomer" data-backdrop="static" data-keyboard="false" tabindex="-1 " role="dialog " aria-labelledby="staticBackdropLabel " aria-hidden="true ">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content ">


            <div class="modal-header">
              <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">New Patient Registration</h5>
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body steps-container">
              <div class="mb-4 the-step patient-info active">
                <div class="avatar-md mx-auto mb-4 d-none">
                  <div class="avatar-title bg-light rounded-circle text-primary h1 ">
                    <i class="mdi mdi-account-multiple-plus "></i>
                  </div>
                </div>

                <div class="row  text-left">
                  <div class="col-12">
                    <h4 class="text-primary text-capitalize">Patient's Details</h4>
                    <form>
                      <div class="row ">
                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Full Name</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-4">
                              <input type="text" class="form-control two-step " placeholder="First Name">
                            </div>

                            <div class="col-4">
                              <input type="text " class="form-control two-step " placeholder="Middle Name">
                            </div>

                            <div class="col-4">
                              <input type="text " class="form-control two-step " placeholder="Last Name">
                            </div>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Date Of Birth</label>
                            <input class="form-control" type="date" value="2019-08-19" id="example-date-input">
                          </div>
                        </div>
                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Nationality</label>
                            <select class="form-control selectpicker bg-white select-revenue" data-live-search="true" title="Select a tenant">
                              <option value="">-- select one --</option>
                              <option value="afghan">Afghan</option>
                              <option value="albanian">Albanian</option>
                              <option value="algerian">Algerian</option>
                              <option value="american">American</option>
                              <option value="andorran">Andorran</option>
                              <option value="angolan">Angolan</option>
                              <option value="antiguans">Antiguans</option>
                              <option value="argentinean">Argentinean</option>
                              <option value="armenian">Armenian</option>
                              <option value="australian">Australian</option>
                              <option value="austrian">Austrian</option>
                              <option value="azerbaijani">Azerbaijani</option>
                              <option value="bahamian">Bahamian</option>
                              <option value="bahraini">Bahraini</option>
                              <option value="bangladeshi">Bangladeshi</option>
                              <option value="barbadian">Barbadian</option>
                              <option value="barbudans">Barbudans</option>
                              <option value="batswana">Batswana</option>
                              <option value="belarusian">Belarusian</option>
                              <option value="belgian">Belgian</option>
                              <option value="belizean">Belizean</option>
                              <option value="beninese">Beninese</option>
                              <option value="bhutanese">Bhutanese</option>
                              <option value="bolivian">Bolivian</option>
                              <option value="bosnian">Bosnian</option>
                              <option value="brazilian">Brazilian</option>
                              <option value="british">British</option>
                              <option value="bruneian">Bruneian</option>
                              <option value="bulgarian">Bulgarian</option>
                              <option value="burkinabe">Burkinabe</option>
                              <option value="burmese">Burmese</option>
                              <option value="burundian">Burundian</option>
                              <option value="cambodian">Cambodian</option>
                              <option value="cameroonian">Cameroonian</option>
                              <option value="canadian">Canadian</option>
                              <option value="cape verdean">Cape Verdean</option>
                              <option value="central african">Central African</option>
                              <option value="chadian">Chadian</option>
                              <option value="chilean">Chilean</option>
                              <option value="chinese">Chinese</option>
                              <option value="colombian">Colombian</option>
                              <option value="comoran">Comoran</option>
                              <option value="congolese">Congolese</option>
                              <option value="costa rican">Costa Rican</option>
                              <option value="croatian">Croatian</option>
                              <option value="cuban">Cuban</option>
                              <option value="cypriot">Cypriot</option>
                              <option value="czech">Czech</option>
                              <option value="danish">Danish</option>
                              <option value="djibouti">Djibouti</option>
                              <option value="dominican">Dominican</option>
                              <option value="dutch">Dutch</option>
                              <option value="east timorese">East Timorese</option>
                              <option value="ecuadorean">Ecuadorean</option>
                              <option value="egyptian">Egyptian</option>
                              <option value="emirian">Emirian</option>
                              <option value="equatorial guinean">Equatorial Guinean</option>
                              <option value="eritrean">Eritrean</option>
                              <option value="estonian">Estonian</option>
                              <option value="ethiopian">Ethiopian</option>
                              <option value="fijian">Fijian</option>
                              <option value="filipino">Filipino</option>
                              <option value="finnish">Finnish</option>
                              <option value="french">French</option>
                              <option value="gabonese">Gabonese</option>
                              <option value="gambian">Gambian</option>
                              <option value="georgian">Georgian</option>
                              <option value="german">German</option>
                              <option value="ghanaian">Ghanaian</option>
                              <option value="greek">Greek</option>
                              <option value="grenadian">Grenadian</option>
                              <option value="guatemalan">Guatemalan</option>
                              <option value="guinea-bissauan">Guinea-Bissauan</option>
                              <option value="guinean">Guinean</option>
                              <option value="guyanese">Guyanese</option>
                              <option value="haitian">Haitian</option>
                              <option value="herzegovinian">Herzegovinian</option>
                              <option value="honduran">Honduran</option>
                              <option value="hungarian">Hungarian</option>
                              <option value="icelander">Icelander</option>
                              <option value="indian">Indian</option>
                              <option value="indonesian">Indonesian</option>
                              <option value="iranian">Iranian</option>
                              <option value="iraqi">Iraqi</option>
                              <option value="irish">Irish</option>
                              <option value="israeli">Israeli</option>
                              <option value="italian">Italian</option>
                              <option value="ivorian">Ivorian</option>
                              <option value="jamaican">Jamaican</option>
                              <option value="japanese">Japanese</option>
                              <option value="jordanian">Jordanian</option>
                              <option value="kazakhstani">Kazakhstani</option>
                              <option value="kenyan" selected>Kenyan</option>
                              <option value="kittian and nevisian">Kittian and Nevisian</option>
                              <option value="kuwaiti">Kuwaiti</option>
                              <option value="kyrgyz">Kyrgyz</option>
                              <option value="laotian">Laotian</option>
                              <option value="latvian">Latvian</option>
                              <option value="lebanese">Lebanese</option>
                              <option value="liberian">Liberian</option>
                              <option value="libyan">Libyan</option>
                              <option value="liechtensteiner">Liechtensteiner</option>
                              <option value="lithuanian">Lithuanian</option>
                              <option value="luxembourger">Luxembourger</option>
                              <option value="macedonian">Macedonian</option>
                              <option value="malagasy">Malagasy</option>
                              <option value="malawian">Malawian</option>
                              <option value="malaysian">Malaysian</option>
                              <option value="maldivan">Maldivan</option>
                              <option value="malian">Malian</option>
                              <option value="maltese">Maltese</option>
                              <option value="marshallese">Marshallese</option>
                              <option value="mauritanian">Mauritanian</option>
                              <option value="mauritian">Mauritian</option>
                              <option value="mexican">Mexican</option>
                              <option value="micronesian">Micronesian</option>
                              <option value="moldovan">Moldovan</option>
                              <option value="monacan">Monacan</option>
                              <option value="mongolian">Mongolian</option>
                              <option value="moroccan">Moroccan</option>
                              <option value="mosotho">Mosotho</option>
                              <option value="motswana">Motswana</option>
                              <option value="mozambican">Mozambican</option>
                              <option value="namibian">Namibian</option>
                              <option value="nauruan">Nauruan</option>
                              <option value="nepalese">Nepalese</option>
                              <option value="new zealander">New Zealander</option>
                              <option value="ni-vanuatu">Ni-Vanuatu</option>
                              <option value="nicaraguan">Nicaraguan</option>
                              <option value="nigerien">Nigerien</option>
                              <option value="north korean">North Korean</option>
                              <option value="northern irish">Northern Irish</option>
                              <option value="norwegian">Norwegian</option>
                              <option value="omani">Omani</option>
                              <option value="pakistani">Pakistani</option>
                              <option value="palauan">Palauan</option>
                              <option value="panamanian">Panamanian</option>
                              <option value="papua new guinean">Papua New Guinean</option>
                              <option value="paraguayan">Paraguayan</option>
                              <option value="peruvian">Peruvian</option>
                              <option value="polish">Polish</option>
                              <option value="portuguese">Portuguese</option>
                              <option value="qatari">Qatari</option>
                              <option value="romanian">Romanian</option>
                              <option value="russian">Russian</option>
                              <option value="rwandan">Rwandan</option>
                              <option value="saint lucian">Saint Lucian</option>
                              <option value="salvadoran">Salvadoran</option>
                              <option value="samoan">Samoan</option>
                              <option value="san marinese">San Marinese</option>
                              <option value="sao tomean">Sao Tomean</option>
                              <option value="saudi">Saudi</option>
                              <option value="scottish">Scottish</option>
                              <option value="senegalese">Senegalese</option>
                              <option value="serbian">Serbian</option>
                              <option value="seychellois">Seychellois</option>
                              <option value="sierra leonean">Sierra Leonean</option>
                              <option value="singaporean">Singaporean</option>
                              <option value="slovakian">Slovakian</option>
                              <option value="slovenian">Slovenian</option>
                              <option value="solomon islander">Solomon Islander</option>
                              <option value="somali">Somali</option>
                              <option value="south african">South African</option>
                              <option value="south korean">South Korean</option>
                              <option value="spanish">Spanish</option>
                              <option value="sri lankan">Sri Lankan</option>
                              <option value="sudanese">Sudanese</option>
                              <option value="surinamer">Surinamer</option>
                              <option value="swazi">Swazi</option>
                              <option value="swedish">Swedish</option>
                              <option value="swiss">Swiss</option>
                              <option value="syrian">Syrian</option>
                              <option value="taiwanese">Taiwanese</option>
                              <option value="tajik">Tajik</option>
                              <option value="tanzanian">Tanzanian</option>
                              <option value="thai">Thai</option>
                              <option value="togolese">Togolese</option>
                              <option value="tongan">Tongan</option>
                              <option value="trinidadian or tobagonian">Trinidadian or Tobagonian</option>
                              <option value="tunisian">Tunisian</option>
                              <option value="turkish">Turkish</option>
                              <option value="tuvaluan">Tuvaluan</option>
                              <option value="ugandan">Ugandan</option>
                              <option value="ukrainian">Ukrainian</option>
                              <option value="uruguayan">Uruguayan</option>
                              <option value="uzbekistani">Uzbekistani</option>
                              <option value="venezuelan">Venezuelan</option>
                              <option value="vietnamese">Vietnamese</option>
                              <option value="welsh">Welsh</option>
                              <option value="yemenite">Yemenite</option>
                              <option value="zambian">Zambian</option>
                              <option value="zimbabwean">Zimbabwean</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Gender</label>
                            <div class="row">
                              <div class="col-auto">
                                <div class="form-check mb-3">
                                  <input class="form-check-input" type="radio" name="gender" id="radioFemale" >
                                  <label class="form-check-label" for="radioFemale">
                                    Female
                                  </label>
                                </div>
                              </div>

                              <div class="col-auto">
                                <div class="form-check mb-3">
                                  <input class="form-check-input" type="radio" name="gender" id="radioMale" >
                                  <label class="form-check-label" for="radioMale">
                                    Male
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Marital Status</label>
                            <select class="form-control selectpicker bg-white select-revenue" title="Select Marital Status" data-live-search="true">
                              <option value="Single">Single</option>
                              <option value="Married">Married</option>
                              <option value="Widowed">Widowed</option>
                              <option value="Separated">Separated</option>
                              <option value="Divorced">Divorced</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Religion</label>
                            <select class="form-control selectpicker bg-white select-revenue" title="Select Religion" data-live-search="true">
                              <option value="African Traditional & Diasporic">African Traditional & Diasporic</option>
                              <option value="Agnostic">Agnostic</option>
                              <option value="Atheist">Atheist</option>
                              <option value="Baha'i">Baha'i</option>
                              <option value="Buddhism">Buddhism</option>
                              <option value="Cao Dai">Cao Dai</option>
                              <option value="Chinese traditional religion">Chinese traditional religion</option>
                              <option value="Christianity">Christianity</option>
                              <option value="Hinduism">Hinduism</option>
                              <option value="Islam">Islam</option>
                              <option value="Jainism">Jainism</option>
                              <option value="Juche">Juche</option>
                              <option value="Judaism">Judaism</option>
                              <option value="Neo-Paganism">Neo-Paganism</option>
                              <option value="Nonreligious">Nonreligious</option>
                              <option value="Rastafarianism">Rastafarianism</option>
                              <option value="Secular">Secular</option>
                              <option value="Shinto">Shinto</option>
                              <option value="Sikhism">Sikhism</option>
                              <option value="Spiritism">Spiritism</option>
                              <option value="Tenrikyo">Tenrikyo</option>
                              <option value="Unitarian-Universalism">Unitarian-Universalism</option>
                              <option value="Zoroastrianism">Zoroastrianism</option>
                              <option value="primal-indigenous">primal-indigenous</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Blood group</label>
                            <select class="form-control selectpicker bg-white select-revenue" title="Select Blood Group" data-live-search="true">
                              <option value="A+">A+</option><option value="A-">A-</option>
                              <option value="B+">B+</option><option value="B-">B-</option>
                              <option value="O+">O+</option><option value="O-">O-</option>
                              <option value="AB+">AB+</option><option value="AB-">AB-</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Occupation</label>
                            <input type="text " class="form-control two-step " placeholder="Patient's Occupation">
                          </div>
                        </div>

                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Contact Information</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-6">
                              <input type="text " class="form-control two-step " placeholder="Phone No">
                            </div>

                            <div class="col-6">
                              <input type="email" class="form-control two-step " placeholder="Email Address">
                            </div>


                          </div>
                        </div>


                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Residence</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select County" data-live-search="true">
                                <option value="">Busia</option>
                                <option value="">Nairobi</option>
                                <option value="">Homabay</option>
                              </select>
                            </div>

                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select Sub County" data-live-search="true">
                                <option value="">Teso North</option>
                                <option value="">Teso South</option>
                                <option value="">Nambale</option>

                                <option value="">Matayos</option>
                                <option value="">Butula</option>
                                <option value="">Funyula</option>
                                <option value="">Budalangi</option>
                              </select>
                            </div>

                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select Ward" data-live-search="true">
                                <option value="">Marachi West</option>
                                <option value="">Marachi North</option>
                                <option value="">Marachi Central</option>
                                <option value="">Kingandole</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Physical Address</label>
                            <textarea name="" id=""  class="form-control" placeholder="Enter Address"></textarea>
                          </div>
                        </div>

                      </div>


                    </form>

                  </div>
                </div>
              </div>
              <div class="mb-4 the-step next-of-kin-modal d-none">
                <h4 class="text-primary text-capitalize">Next Of Kin Details</h4>
                <div class="row">

                  <div class="col-12 mb-4">
                    <label for="" class="text-capitalize">Relationship with Patient Being registerd</label>
                    <select class="form-control selectpicker bg-white select-revenue" title="Select Next Of Kin's Relationship with the patient being registered" data-live-search="true">
                      <option value="">Mother</option>
                      <option value="">Father</option>
                      <option value="">Daughter</option>

                      <option value="">Son</option>
                      <option value="">Sister</option>
                      <option value="">Brother</option>

                      <option value="">Friend</option>
                      <option value="">Uncle</option>
                      <option value="">Aunt</option>
                    </select>
                  </div>

                  <div class="col-12 ">
                    <div class="">
                      <label for="digit1-input " class="">Next Of Kin Full Names</label>
                    </div>
                  </div>


                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-4">
                        <input type="text " class="form-control two-step " placeholder="First Name">
                      </div>

                      <div class="col-4">
                        <input type="text" class="form-control two-step " placeholder="Middle Name">
                      </div>

                      <div class="col-4">
                        <input type="text " class="form-control two-step " placeholder="Last Name">
                      </div>
                    </div>
                  </div>

                  <div class="col-12 ">
                    <div class="">
                      <label for="digit1-input " class="">Next Of Kin Contact information</label>
                    </div>
                  </div>


                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-6">
                        <input type="text" class="form-control two-step " placeholder="Phone Number">
                      </div>

                      <div class="col-6">
                        <input type="email" class="form-control two-step " placeholder="Email address">
                      </div>


                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="">
                      <label for="digit1-input " class="">Physical Address</label>
                      <textarea name="" id=""  class="form-control" placeholder="Enter Address"></textarea>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="modal-footer d-flex">
              <div class="d-none">
                <button data-toggle="modal" data-target="#subscribeModal" data-dismiss="modal" type="button" class="btn btn-link waves-effect">Back To Patient Search</button>
              </div>
              <div class="d-flex modal-next-prev-container">
                <button type="button" class="btn btn-outline-secondary btn-prev waves-effect waves-effect waves-light me-3">
                  <i class="bx bx-left-arrow-alt font-size-16 align-middle me-2"></i> Previouse
                </button>

                <button type="button" class="btn btn-primary waves-effect waves-effect waves-light btn-next">
                  Next <i class="bx bx-right-arrow-alt font-size-16 align-middle me-2"></i>
                </button>

                <button type="button" class="btn btn-submit btn-success d-none ml-3 ms-3 waves-effect waves-effect waves-light btn-next">
                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Submit Application
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Patient registration -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>


    </div>

    </body>


  </div>
</template>

<script>
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, execute, getRight } from "@/api";

export default {
  name: "EmployeeApprovalsRejected",
  components: { NavigationBar },
  data() {
    return {
      alert: {
        success: false,
        info: false,
        failed: false
      },
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      employeeData: []
    };
  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },
    gotTo(employeeDataId,route){
      sessionStorage.setItem('employeeDataId', employeeDataId);
      this.$router.push(route);
    },
    getEmployeeData() {
      const data = new FormData();
      data.append("function", "getEmployeeData");
      data.append("approved", "REJECTED");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.employeeData = res.data.data.employeeData.map((item) => {
                // Parse the 'data' field
                let parsedData = item.data ? JSON.parse(item.data) : {};
                return {
                  id: item.id,
                  firstName: parsedData.employeeData?.firstName || "N/A",
                  lastName: parsedData.employeeData?.lastName || "N/A",
                  nationalId: parsedData.employeeData?.nationalId || "N/A",
                  contractType: parsedData.extraDetails?.employmentType || "N/A",
                  salary: parsedData.bankDetails?.netSalary || "N/A",
                  department: parsedData.employmentDetails?.department || "N/A",
                  designation: parsedData.employmentDetails?.designation || "N/A",
                  dateCreated: item.dateCreated || "N/A",
                  createdBy: item.createdBy || "N/A"
                };
              });
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    }
  }
};
</script>


<style scoped>

</style>